var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_759",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3463 15.5385C17.3463 17.0532 16.8245 18.3421 15.7808 19.4053C14.7373 20.4684 13.4611 21 11.9521 21C10.4431 21 9.16357 20.4684 8.11357 19.4053C7.06357 18.3421 6.53857 17.0532 6.53857 15.5385V6.80775C6.53857 5.75008 6.90232 4.851 7.62982 4.1105C8.35749 3.37017 9.25016 3 10.3078 3C11.3655 3 12.2581 3.37017 12.9856 4.1105C13.7132 4.851 14.0771 5.75008 14.0771 6.80775V15.077C14.0771 15.6642 13.8722 16.1699 13.4623 16.5943C13.0527 17.0186 12.5533 17.2308 11.9643 17.2308C11.3753 17.2308 10.8687 17.0219 10.4443 16.6043C10.02 16.1866 9.80782 15.6775 9.80782 15.077V6.76925H10.8078V15.077C10.8078 15.3962 10.9171 15.6682 11.1356 15.8932C11.3542 16.1182 11.6232 16.2308 11.9423 16.2308C12.2617 16.2308 12.5306 16.1182 12.7491 15.8932C12.9677 15.6682 13.0771 15.3962 13.0771 15.077V6.7885C13.0732 6.0115 12.8061 5.3525 12.2756 4.8115C11.7452 4.2705 11.0893 4 10.3078 4C9.53232 4 8.87691 4.27375 8.34157 4.82125C7.80624 5.36858 7.53857 6.03075 7.53857 6.80775V15.5385C7.53474 16.7732 7.96232 17.8254 8.82132 18.6953C9.68016 19.5651 10.7261 20 11.9591 20C13.1744 20 14.2075 19.5651 15.0583 18.6953C15.9092 17.8254 16.3385 16.7732 16.3463 15.5385V6.76925H17.3463V15.5385Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attach_file.802e4edcb7c8ce5475a9dd2ca6d504fe.svg";
export { ForwardRef as ReactComponent };